<div class="relatorio-analitico-container">
    <div class="toolbar no-print">
        <div class="flex justify-content-between align-items-center flex-wrap gap-2">
            <button pButton pRipple type="button" label="Voltar" icon="pi pi-arrow-left"
                class="p-button-secondary" (click)="voltar()"></button>

            <div class="flex align-items-center flex-wrap gap-2">
                <button pButton pRipple type="button" label="Exportar Excel" icon="pi pi-file-excel"
                    class="p-button-success" (click)="exportarExcel()" [disabled]="loading"></button>
                <button pButton pRipple type="button" label="Exportar PDF" icon="pi pi-file-pdf"
                    class="p-button-danger" (click)="exportarPDF()" [disabled]="loading"></button>
            </div>
        </div>
    </div>

    <div class="relatorio-scroll-wrapper">
        <div *ngIf="loading" class="loading-container">
            <p-progressSpinner [style]="{width: '56px', height: '56px'}" strokeWidth="6"
                fill="#EEEEEE" animationDuration=".5s"></p-progressSpinner>
            <p>Carregando relatório analítico...</p>
        </div>

        <div *ngIf="!loading" class="content-grid">
            <section class="card-block no-print">
                <div class="filters-grid">
                    <div class="field">
                        <label for="range-analitico" class="filter-label-fixed">Período</label>
                        <p-datepicker appendTo="body" dateFormat="dd/mm/yy" placeholder="Período"
                            [(ngModel)]="rangeDate" selectionMode="range" inputId="range-analitico"
                            styleClass="w-full">
                        </p-datepicker>
                    </div>

                    <div class="field">
                        <label for="estacao-analitico" class="filter-label-fixed">Estações</label>
                        <p-multiSelect appendTo="body" inputId="estacao-analitico" [filter]="true" filterLocale="pt-BR" [options]="dropDownEstacao"
                            [(ngModel)]="filtrosAplicados.estacoes" optionLabel="label" placeholder="Estações"
                            [maxSelectedLabels]="1" selectedItemsLabel="{0} estações selecionadas">
                        </p-multiSelect>
                    </div>

                    <div class="field">
                        <label for="tipo-evento-analitico" class="filter-label-fixed">Tipos de evento</label>
                        <p-multiSelect appendTo="body" inputId="tipo-evento-analitico" [filter]="true" [options]="dropDownTipoEvento"
                            [(ngModel)]="filtrosAplicados.tiposEvento" optionLabel="label" placeholder="Tipos de evento">
                        </p-multiSelect>
                    </div>

                    <div class="actions">
                        <button pButton pRipple type="button" icon="pi pi-search" class="p-button-rounded p-button-success"
                            [disabled]="!rangeDate || rangeDate.length < 2" pTooltip="Filtrar" (click)="carregarDados()"></button>
                        <button pButton pRipple type="button" icon="pi pi-filter"
                            class="p-button-rounded p-button-text p-button-plain" pTooltip="Filtro avançado"
                            (click)="toggleFiltroAvancado()"></button>
                    </div>
                </div>

                <div *ngIf="exibirFiltroAvancado" class="advanced-grid">
                    <div class="field checkbox-field checkbox-field-full">
                        <div class="field-checkbox">
                            <p-checkbox [(ngModel)]="filtrosAplicados.somenteSituacaoEventoUm"
                                inputId="somente_situacao_evento_1" [binary]="true">
                            </p-checkbox>
                            <label for="somente_situacao_evento_1" class="p-checkbox-label">
                                Mostrar somente dias com situacao_evento = 1
                            </label>
                        </div>
                    </div>
                    <div class="field">
                        <p-multiSelect [options]="dropDownGrupos" appendTo="body" [filter]="true"
                            [(ngModel)]="filtrosAplicados.grupos" optionLabel="label" placeholder="Grupos">
                        </p-multiSelect>
                    </div>
                    <div class="field">
                        <p-multiSelect [options]="dropDownClientes" appendTo="body" [filter]="true"
                            [(ngModel)]="filtrosAplicados.clientes" optionLabel="label" placeholder="Clientes">
                        </p-multiSelect>
                    </div>
                    <div class="field">
                        <p-multiSelect [options]="dropDownSensores" appendTo="body" [filter]="true"
                            [(ngModel)]="filtrosAplicados.sensores" optionLabel="label" placeholder="Sensores">
                        </p-multiSelect>
                    </div>
                    <div class="field">
                        <input type="text" class="p-inputtext p-component" placeholder="PLU"
                            [(ngModel)]="filtrosAplicados.plu" pInputText>
                    </div>
                    <div class="field">
                        <input type="text" class="p-inputtext p-component" placeholder="FLU"
                            [(ngModel)]="filtrosAplicados.flu" pInputText>
                    </div>
                    <div class="field">
                        <p-multiSelect [options]="dropDownIntegradores" appendTo="body" [filter]="true"
                            [(ngModel)]="filtrosAplicados.integradores" optionLabel="label" placeholder="Integradores">
                        </p-multiSelect>
                    </div>
                    <div class="field">
                        <p-multiSelect [options]="dropDownColetores" appendTo="body" [filter]="true"
                            [(ngModel)]="filtrosAplicados.coletores" optionLabel="descricao" placeholder="Coletores">
                        </p-multiSelect>
                    </div>
                </div>
            </section>

            <section class="hero-card">
                <div class="hero-header">
                    <div>
                        <h1>Relatório Analítico de Eventos</h1>
                        <p>Consulta operacional por período com totais, estações afetadas e detalhamento pesquisável.</p>
                    </div>
                    <div class="hero-meta">
                        <span><strong>Período:</strong> {{ periodoFormatado || 'Não informado' }}</span>
                        <span><strong>Gerado em:</strong> {{ dataGeracao }}</span>
                    </div>
                </div>

                <div class="filters-box">
                    <strong>Filtros aplicados:</strong>
                    <span>{{ getDescricaoFiltros() }}</span>
                </div>
            </section>

            <section class="summary-grid">
                <article class="summary-card">
                    <span class="summary-label">Estações filtradas</span>
                    <strong class="summary-value">{{ resumo.total_estacoes_filtradas }}</strong>
                </article>
                <article class="summary-card">
                    <span class="summary-label">Estações com evento</span>
                    <strong class="summary-value">{{ resumo.total_estacoes_com_evento }}</strong>
                </article>
                <article class="summary-card">
                    <span class="summary-label">Total de eventos</span>
                    <strong class="summary-value">{{ resumo.total_eventos }}</strong>
                </article>
                <article class="summary-card">
                    <span class="summary-label">Tipos com evento</span>
                    <strong class="summary-value">{{ resumo.total_tipos_com_evento }}</strong>
                </article>
            </section>

            <section class="card-block">
                <div class="section-header">
                    <h2>Resumo por tipo de evento</h2>
                </div>

                <p-table [value]="porTipo" styleClass="p-datatable-gridlines">
                    <ng-template pTemplate="header">
                        <tr>
                            <th>Tipo de evento</th>
                            <th>Total de eventos</th>
                            <th>Estações com evento</th>
                            <th>Dias com evento</th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-row>
                        <tr>
                            <td>{{ row.tipo_evento_descricao }}</td>
                            <td>{{ row.total_eventos }}</td>
                            <td>{{ row.total_estacoes_com_evento }}</td>
                            <td>{{ row.total_dias_com_evento }}</td>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="emptymessage">
                        <tr>
                            <td colspan="4" class="empty-message">Nenhum tipo de evento encontrado no período filtrado.</td>
                        </tr>
                    </ng-template>
                </p-table>
            </section>

            <section class="card-block no-print graphic-cta-block">
                <div class="graphic-cta-content">
                    <div>
                        <h2>Painel gráfico gerencial</h2>
                        <p>Visualize comparativos, tendências e concentrações dos monitoramentos conforme os filtros aplicados.</p>
                    </div>
                    <button pButton pRipple type="button" label="Abrir relatório gráfico" icon="pi pi-chart-bar"
                        class="p-button-warning" (click)="abrirRelatorioGrafico()" [disabled]="!temDadosGraficos()">
                    </button>
                </div>
            </section>

            <section class="card-block">
                <div class="section-header section-header-details">
                    <h2>Detalhamento por dia e estação</h2>
                    <span class="p-input-icon-left details-search">
                        <i class="pi pi-search"></i>
                        <input pInputText type="text" [value]="globalFilter" (input)="aplicarFiltroGlobal($event)"
                            placeholder="Buscar por data, estação, cliente, evento ou status" />
                    </span>
                </div>

                <p-table #detalhesTable [value]="detalhes" [paginator]="true" [rows]="20" [rowHover]="true"
                    styleClass="p-datatable-gridlines"
                    [globalFilterFields]="['data_formatada','estacao_descricao','cliente_nome','tipo_evento_descricao','status_label']"
                    currentPageReportTemplate="Exibindo {first} a {last} de {totalRecords} registros"
                    [showCurrentPageReport]="true">
                <ng-template pTemplate="header">
                    <tr>
                        <th>Data</th>
                        <th>Estação</th>
                        <th>Cliente</th>
                        <th>Tipo de evento</th>
                        <th>Quantidade</th>
                        <th>Status do dia</th>
                        <th style="width: 90px;">Ações</th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-row>
                    <tr>
                        <td>{{ row.data_formatada }}</td>
                            <td>{{ row.estacao_descricao }}</td>
                        <td>{{ row.cliente_nome || '-' }}</td>
                        <td>{{ row.tipo_evento_descricao }}</td>
                        <td>{{ getQuantidadeLista(row) }}</td>
                        <td>
                            <span class="status-pill" [style.background]="row.status_cor">
                                {{ row.status_label }}
                            </span>
                        </td>
                        <td class="acoes-col">
                            <button pButton pRipple type="button" icon="pi pi-eye"
                                class="p-button-rounded p-button-text p-button-info"
                                pTooltip="Abrir detalhes da estação no dia"
                                (click)="abrirDialogEstacao(row)"></button>
                        </td>
                    </tr>
                </ng-template>
                <ng-template pTemplate="emptymessage">
                    <tr>
                        <td colspan="7" class="empty-message">Nenhum detalhe encontrado para os filtros informados.</td>
                    </tr>
                </ng-template>
            </p-table>
        </section>
    </div>
</div>

<p-dialog [(visible)]="modalEstacao" [breakpoints]="{'960px': '75vw', '640px': '100vw'}" [style]="{width: '75vw'}"
    [modal]="true" [draggable]="false" [resizable]="false" styleClass="station-modal">

    <ng-template pTemplate="header">
        <div class="modal-header-content">
            <a [routerLink]="['/dashboard/', estacaoDialog?.id, dataRotaModal]" class="modal-header-link">
                <i class="pi pi-external-link modal-header-icon"></i>
                <h5 class="modal-header-title">{{ tituloModalEstacao }}</h5>
            </a>
        </div>
    </ng-template>

    <div class="modal-content">
        <div class="station-info-card" *ngIf="estacaoDialog">
            <div class="station-info-header">
                <i class="pi pi-info-circle station-info-icon"></i>
                <h6 class="station-info-title">Informações da Estação</h6>
            </div>
            <div class="station-info-body">
                <div class="info-row">
                    <span class="info-label">ID:</span>
                    <span class="info-value">{{ estacaoDialog?.id }}</span>
                </div>
                <div class="info-row">
                    <span class="info-label">Cód. PLU:</span>
                    <span class="info-value">{{ estacaoDialog?.plu }}</span>
                    <span class="info-label info-label-spaced">Cód. FLU:</span>
                    <span class="info-value">{{ estacaoDialog?.flu }}</span>
                </div>
                <div class="info-row">
                    <span class="info-label">Localização:</span>
                    <span class="info-value">{{ estacaoDialog?.latitude }}, {{ estacaoDialog?.longitude }}</span>
                </div>
            </div>
        </div>

        <div *ngIf="loadingDialogEstacao" class="loading-container dialog-loading-state">
            <p-progressSpinner [style]="{width: '56px', height: '56px'}" strokeWidth="6"
                fill="#EEEEEE" animationDuration=".5s"></p-progressSpinner>
            <p>Carregando detalhes da estação...</p>
        </div>

        <div class="p-fluid grid modal-sections" *ngIf="!loadingDialogEstacao">
            <div class="col-12 md:col-6">
                <div class="events-card">
                    <div class="card-header">
                        <i class="pi pi-calendar-times card-header-icon"></i>
                        <h6 class="card-header-title">Eventos</h6>
                    </div>
                    <div class="card-body">
                        <div *ngFor="let item of dadosDialogEstacao">
                            <p-message *ngIf="item.eventos.length === 0" severity="info"
                                text="Nenhum evento encontrado." styleClass="empty-message"></p-message>
                            <div *ngFor="let row of item.eventos" class="event-row">
                                <div class="event-icon">
                                    <i [ngClass]="getIconeEvento(row)" [ngStyle]="{'color': row.cor}"></i>
                                </div>
                                <div class="event-content">
                                    <span class="event-name">{{ row.tipo_evento.descricao }}</span>
                                    <span class="event-count" [pTooltip]="row.tooltip">
                                        {{ row.total_computado }} / {{ row.maximo_normalidade_eventos }}
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-12 md:col-6">
                <div class="monitoring-card">
                    <div class="card-header">
                        <i class="pi pi-eye card-header-icon"></i>
                        <h6 class="card-header-title">Monitoramentos</h6>
                    </div>
                    <div class="card-body">
                        <div *ngFor="let item of dadosDialogEstacao">
                            <p-message *ngIf="item.monitoramento.length === 0" severity="info"
                                text="Nenhum monitoramento encontrado." styleClass="empty-message"></p-message>
                            <div *ngFor="let row of item.monitoramento" class="monitoring-row">
                                <div class="monitoring-icon">
                                    <i [ngClass]="getIconeMonitoramento(row)" [ngStyle]="{'color': row.cor}"></i>
                                </div>
                                <div class="monitoring-content">
                                    <span class="monitoring-name">{{ row.tipo_evento }}</span>
                                    <span class="monitoring-dates" pTooltip="Inicio / Fim">
                                        {{ row.data_hora_monitoramento }} / {{ row.data_hora_ultima_situacao }}
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <ng-template pTemplate="footer">
        <div class="modal-footer">
            <button pButton pRipple type="button" icon="pi pi-table" (click)="abrirLeiturasEstacao()"
                label="Ver leituras do dia" class="p-button-outlined p-button-info"
                [disabled]="loadingDialogEstacao || !estacaoDialog?.id"></button>
            <button pButton pRipple type="button" icon="pi pi-arrow-left" (click)="changeDateDialogEstacao('ontem')"
                label="Data anterior" class="p-button-outlined"></button>
            <button pButton pRipple type="button" (click)="changeDateDialogEstacao('amanha')" iconPos="right"
                icon="pi pi-arrow-right" label="Próxima data" class="p-button-outlined"></button>
        </div>
    </ng-template>
</p-dialog>

<app-leitura-estacao-dialog></app-leitura-estacao-dialog>

<p-dialog [(visible)]="modalRelatorioGrafico" [breakpoints]="{'1400px': '92vw', '960px': '96vw', '640px': '100vw'}"
    [style]="{width: '92vw', maxWidth: '1440px'}" [modal]="true" [draggable]="false" [resizable]="false"
    styleClass="graphic-report-modal">
    <ng-template pTemplate="header">
        <div class="modal-header-content modal-header-content-space">
            <div>
                <h5 class="modal-header-title">Relatório gráfico dos monitoramentos</h5>
                <span class="modal-header-subtitle">{{ periodoFormatado }}</span>
            </div>
            <button pButton pRipple type="button" icon="pi pi-file-pdf" label="Exportar PDF"
                class="p-button-danger p-button-sm" (click)="exportarRelatorioGraficoPDF()"
                [loading]="exportandoGraficoPdf" [disabled]="!temDadosGraficos() || exportandoGraficoPdf">
            </button>
        </div>
    </ng-template>

    <div class="graphic-report-content">
        <div *ngIf="temDadosGraficos(); else semDadosGraficos">
            <div #relatorioGraficoPagina1 class="graphic-pdf-page graphic-pdf-page-1">
                <div class="graphic-report-head graphic-report-head-compact">
                    <div>
                        <span class="graphic-report-eyebrow">MITSAT • Monitoramento de Estações</span>
                        <h3>Visão gerencial dos eventos filtrados</h3>
                        <p>Consolidação executiva para avaliação de volume, tendência e concentração das ocorrências.</p>
                    </div>
                    <div class="graphic-report-meta">
                        <span><strong>Período:</strong> {{ periodoFormatado || 'Não informado' }}</span>
                        <span><strong>Gerado em:</strong> {{ dataGeracao }}</span>
                    </div>
                </div>

                <div class="filters-box graphic-filters-box graphic-filters-box-compact">
                    <strong>Escopo analisado:</strong>
                    <span>{{ getDescricaoFiltros() }}</span>
                </div>

                <section class="graphic-kpi-grid graphic-kpi-grid-compact">
                    <article class="graphic-kpi-card" *ngFor="let indicador of indicadoresGerenciais">
                        <span class="graphic-kpi-label">{{ indicador.label }}</span>
                        <strong class="graphic-kpi-value">{{ indicador.valor }}</strong>
                        <small class="graphic-kpi-hint">{{ indicador.destaque }}</small>
                    </article>
                </section>

                <section class="graphic-insights-grid graphic-insights-grid-compact">
                    <article class="graphic-insight-card" *ngFor="let insight of insightsGerenciais">
                        <span class="graphic-insight-title">{{ insight.titulo }}</span>
                        <strong class="graphic-insight-value">{{ insight.descricao }}</strong>
                    </article>
                </section>

                <section class="graphic-charts-grid graphic-charts-grid-page1">
                    <article class="graphic-chart-card graphic-chart-card-page1">
                        <p-chart type="bar" [data]="graficoTiposData" [options]="graficoTiposOptions"></p-chart>
                    </article>

                    <article class="graphic-chart-card graphic-chart-card-page1">
                        <p-chart type="bar" [data]="graficoEstacoesData" [options]="graficoEstacoesOptions"></p-chart>
                    </article>
                </section>
            </div>

            <div #relatorioGraficoPagina2 class="graphic-pdf-page graphic-pdf-page-2">
                <article class="graphic-chart-card graphic-chart-card-line">
                    <p-chart type="line" [data]="graficoLinhaData" [options]="graficoLinhaOptions"></p-chart>
                </article>
            </div>

            <div #relatorioGraficoPagina3 class="graphic-pdf-page graphic-pdf-page-3">
                <article class="graphic-chart-card graphic-chart-card-clients">
                    <p-chart type="bar" [data]="graficoClientesData" [options]="graficoClientesOptions"></p-chart>
                </article>
            </div>
        </div>

        <ng-template #semDadosGraficos>
            <div class="empty-graphic-state">
                <i class="pi pi-chart-bar"></i>
                <h4>Sem dados para compor o painel</h4>
                <p>Refine os filtros ou selecione um período com ocorrências para gerar a visão gráfica.</p>
            </div>
        </ng-template>
    </div>
</p-dialog>
</div>
